// TODO: Remove no-shadow eslint disable after fixed: https://github.com/typescript-eslint/typescript-eslint/issues/2484
// eslint-disable-next-line no-shadow
export enum DriversMutationTypes {
    SET_DRIVER = 'SET_DRIVER',
    SET_DRIVER_UUID = 'SET_DRIVER_UUID',
    SET_DRIVER_LOADING_PAGE = 'SET_DRIVER_LOADING_PAGE'
  }
  